import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { action, observable } from 'mobx';
import { IGetAllProjectsObject } from 'cd-eft/models/Projects/projectsLibrary';
import { RouteComponentProps } from 'react-router-dom';
import stores from 'cd-eft/models/Stores';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import { getProjects, projectClassId } from '../ProjectContainer/ProjectContainerVM';
import { updateNote } from 'cd-eft/business/Projects/saveNote';
import { getSpatialRefByProject } from 'cd-eft/components/Projects/ProjectsLibrary/ProjectsLibraryVM';
import * as SETAPI from 'cd-eft/services/eftSetApi';

const efh2Store = stores.AppStore.efh2Store;
const designStore = stores.AppStore.designStore;
const setStore = stores.AppStore.surveyEngineeringStore;
const pitDesignStore = stores.AppStore.pitDesignStore;
const padDesignStore = stores.AppStore.padDesignStore;
const landLevelingStore = stores.AppStore.landLevelingDesignStore;
const alignmentStore = stores.AppStore.alignmentDesignStore;
const libraryStore = stores.AppStore.projectsLibraryStore;
const waterwayDesignStore = stores.AppStore.waterwayDesignStore;
// Need to change for new ProjectDataObject ?
export interface IProjectActionsProps {
  project: IGetAllProjectsObject;
  fromProjectView?: boolean;
}

export class ProjectActionsVM {
  props: IProjectActionsProps;
  history: RouteComponentProps['history'];
  url: string;
  @observable sessionId: string;
  constructor(props: IProjectActionsProps, history: RouteComponentProps['history'], url: string) {
    this.props = props;
    this.project = props.project;
    this.history = history;
    this.url = url;
    this.sessionId = this.props.project.sessionList[0].sessionUuid;
  }

  @observable project = {} as IGetAllProjectsObject;

  // download Project  ->
  @observable showDownloadPopup: boolean = false;

  @action.bound toggleDownloadPopup() {
    this.showDownloadPopup = !this.showDownloadPopup;
  }
  @action.bound handleDownloadProject(e: any) {
    if (!this.props.fromProjectView) e.stopPropagation();
    this.toggleDownloadPopup();
  }
  // <- download Project

  // Share Project ->
  @observable timeout: any = null;
  @observable copied: boolean = false;
  @action.bound setCopied(isCopied: boolean) {
    this.copied = isCopied;
  }
  @action.bound handleShareProject(e: any) {
    const fromProjectView = this.props.fromProjectView;
    if (!fromProjectView) e.stopPropagation();
    const projectId = this.project.projectUuid;
    this.setCopied(true);
    const el = document.createElement('input');
    if (fromProjectView) {
      el.value = window.location.href;
    }
    if (!fromProjectView && projectId) {
      el.value = `${window.location.href}/${projectId}`;
    }
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.setCopied(false);
    }, 3000);
  }
  // <- Share Project

  // loadProject ->
  // should accept both IGetAllProjectsObject and ProjectDataObject
  @action.bound async handleLoadProject(e: any): Promise<void> {
    if (!this.props.fromProjectView) e.stopPropagation();
    // This is for loading different types of project
    const classString = String(this.project.projectClassId);
    switch (parseInt(classString)) {
      case projectClassId.design: //Design project
        this.loadDesignProject(this.project);
        break;
      case projectClassId.hydrology: //Analysis-Hydrology project
        this.loadHydrologyProject(this.project);
        break;
      default:
        MessageCenter.addError('THIS TYPE OF PROJECT IS NOT CURRENTLY IMPLEMENTED');
        // throw new Error('THIS TYPE OF PROJECT IS NOT CURRENTLY IMPLEMENTED');
        break;
    }
    //// Enable switch when classID is implemented on the back-end
    switch (this.project.projectClassId) {
      case projectClassId.design: //Design project
        this.history.push(`/design/${this.project.projectUuid}`);
        break;
      case projectClassId.hydrology: //Analysis-Hydrology project
        this.history.push(`/analysis/hydrology/single-watershed/${this.project.projectUuid}`);
        break;
      default:
        break;
    }
    if (this.project.projectUuid !== undefined) await getSpatialRefByProject(this.project.projectUuid);
  }
  private loadDesignProject(project: any) {
    // first reset project store
    setStore.reset();
    setStore.resetTransformation();
    padDesignStore.reset();
    landLevelingStore.reset();
    alignmentStore.reset();
    pitDesignStore.reset();
    designStore.reset();
    waterwayDesignStore.reset();
    designStore.projectsStore.reset();
    designStore.projectsStore.currentProject = project;
    // set current session here
    if (designStore.projectsStore.currentProject.sessionList.length)
      designStore.projectsStore.currentSessionId = designStore.projectsStore.currentProject.sessionList[0].sessionUuid;
    project = designStore.projectsStore.currentProject;
    designStore.projectsStore.currentProjectId = project.projectUuid;
  }
  private async loadHydrologyProject(project: any) {
    // first reset project store
    // clear rainfall & drainage form + results.
    efh2Store.reset();
    efh2Store.projectsStore.reset();
    // WARNING: implicit type cast from ProjectDataObject[] to observable ProjectDataObject, not sure if this is an issue
    efh2Store.projectsStore.currentProject = project;
    // NOTE: set data back to current project to ensure referential integrity, just to be safe
    project = efh2Store.projectsStore.currentProject;
    efh2Store.projectsStore.currentProjectId = project.projectUuid;
    await updateNote();
  }
  // <- loadProject

  // Delete Project ->
  @observable showDeletePopup: boolean = false;
  @action.bound deletePopupToggle() {
    this.showDeletePopup = !this.showDeletePopup;
  }
  @action.bound handleDeleteProject(e: any): void {
    if (!this.props.fromProjectView) e.stopPropagation();
    this.deletePopupToggle();
  }
  ////// The delete function only needs minor changes to reflect name changes for some variables and potential input changes
  @action.bound async deleteProjectAction() {
    const projectId = this.project.projectUuid;
    libraryStore.decrementLoading();
    try {
      await PRJAPI.EftProjectController.softDeleteProjectUsingDELETE(projectId);

      // If deleting currently loaded project, reset loaded project
      if (efh2Store.projectsStore.currentProject.projectUuid === projectId) {
        efh2Store.projectsStore.reset();
      } else if (designStore.projectsStore.currentProject.projectUuid === projectId) {
        designStore.projectsStore.reset();
      }
      getProjects();
      MessageCenter.clearMessages();
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    } finally {
      this.deletePopupToggle();
      this.project = {} as IGetAllProjectsObject;
      this.history.push('/projects');
    }
    libraryStore.decrementLoading();
  }
  @action.bound async getAllDesignElementsBySession(sessionID) {
    // MessageCenter.clearMessages();
    try {
      const response = await SETAPI.DesignElementController.getAllDesignElementsBySessionUsingGET(this.sessionId);
      if (response.data && response.data.length > 0) {
        return response.data;
      } 
    } catch (error) {
      MessageCenter.addError((error as Error).message);
      return;
    }
  }
}
